/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
export const Patterns = {
  HEX_4   : /^0x[a-fA-F0-9]{2}$/,
  HEX_10  : /^0x[a-fA-F0-9]{8}$/,
  HEX_12  : /^0x[a-fA-F0-9]{10}$/,
  NUMERIC : /^[0-9]+$/
};

export const Validators = {
  HEX_4 : {
    required : true,
    pattern  : Patterns.HEX_4
  },
  HEX_10 : {
    required : true,
    pattern  : Patterns.HEX_10
  },
  HEX_12 : {
    required : true,
    pattern  : Patterns.HEX_12
  },
  NUMERIC : {
    required : true,
    pattern  : Patterns.NUMERIC
  }
};

/**
 * Creates a validation object with the given pattern and required flag.
 * 
 * @param pattern  - The regex pattern to validate against
 * @param required - Whether the field is required (default true)
 * 
 * @returns A validator config object
 */
export const createValidator = (pattern: RegExp, required: boolean = true) => ({required, pattern});
